import React from 'react';

export default class Page4 extends React.Component {

    render() {

        return <div id="region-main-pad">
            <div id="region-main"><span id="user-notifications"/>
                <div className="region-content">
                    <div role="main"><span id="maincontent"/>
                        <section>
                            <div className="">
                                <div className="ilead-rgt">
                                    <div className="innerpadding">
                                        <div className="ilead-contentarea">
                                            <div className="lightgreencontentbg separator-pad">
                                                <div className="border_subtitle">Off the top of your head
                                                </div>
                                                <ul className="greenbullet-list uiheading">
                                                    <li><p>Find someone uninvolved to listen to your
                                                        description of the issue.</p></li>
                                                    <li><p>Talk to them freely for as long as you can,
                                                        describing the situation as fully as you can. Aim
                                                        for at least 5 minutes.</p></li>
                                                    <li><p>While talking, write down anything that seems
                                                        interesting, strange or unusual about what you’re
                                                        describing.</p></li>
                                                    <li><p>Your friend then responds in a similarly open
                                                        way, telling you what they’ve heard and any ideas
                                                        that occur to them.</p></li>
                                                    <li><p>You then describe your feelings about their
                                                        observations for 2 minutes.</p></li>
                                                    <li className="cntareap"><p>Write down any insights
                                                        you’ve gained from the process.</p></li>
                                                </ul>
                                            </div>
                                            <div className="lightgreencontentbg separator-pad">
                                                <div className="border_subtitle">Use Post-its</div>
                                                <ul className="greenbullet-list uiheading">
                                                    <li><p>Use post-it notes to write down all your ideas
                                                        about the issue.</p></li>
                                                    <li><p>Then, draw a circle on a flip chart and stick the
                                                        post-its you want to keep inside it.</p></li>
                                                    <li className="cntareap"><p>Look at the circle of ideas
                                                        and ask yourself why you think they’re plausible.
                                                        Then, list anything that might prevent them
                                                        succeeding.</p></li>
                                                </ul>
                                            </div>
                                            <div className="lightgreencontentbg">
                                                <div className="border_subtitle">Ask why and how?</div>
                                                <ul className="greenbullet-list uiheading">
                                                    <li className="cntareap"><p>For example: ‘How can I
                                                        secure the organisation’s future?’</p><p></p></li>

                                                </ul>
                                            </div>
                                            <br/>
                                            <div className="paraspace"><p><strong>Ask why?</strong></p>
                                            </div>
                                            <ul className="greenbullet-list uiheading">
                                                <li><p>To ensure we keep our competitive edge.</p></li>
                                                <li><p>To bring fresh ideas from outside our
                                                    organisation.</p></li>
                                            </ul>
                                            <p></p>
                                            <div className="paraspace"><p><strong>Then ask how?</strong>
                                            </p></div>
                                            <ul className="greenbullet-list uiheading">
                                                <li><p>Revisit our marketing techniques to ensure they
                                                    reach as wide a talent pool as possible.</p></li>
                                                <li><p>By reviewing and implementing current recruitment
                                                    best practice.</p></li>
                                            </ul>
                                            <p style={{paddingTop: '10px!important'}}>Keep asking why and
                                                how, recording your answers as you go until you run out
                                                of them.</p>
                                            <div className="border_subtitle">Ideas</div>
                                            <div className="paraspace"><p>There’s a difference between
                                                thoughts and ideas. A thought is <span
                                                    className="green brownbold">‘I’m bored’</span>, and
                                                the resulting idea: <span className="green brownbold">‘I’ll call a friend to meet up with’</span>.
                                                To turn a thought into an idea and then action, ask:</p>
                                            </div>
                                            <ul className="greenbullet-list uiheading">
                                                <li><p>How will that work?</p></li>
                                                <li><p>What do I need to do to turn that into
                                                    action?</p></li>
                                                <li><p style={{paddingBottom: '15px !important'}}>What
                                                    might that look like if I could see it?</p></li>
                                            </ul>
                                            <div className="border_subtitle">Stimuli</div>

                                            <div className="paraspace"><p>Do something to break your
                                                train of thought and familiar method of categorisation,
                                                as we described earlier, to let in a different
                                                perspective:</p></div>
                                            <ul className="greenbullet-list uiheading">
                                                <li><p>Watch a film related to the issue.</p></li>
                                                <li><p>Find an analogy or similar object, process or
                                                    job.</p></li>
                                                <li><p>Play a game.</p></li>
                                                <li><p>Use magazine cuttings to represent the issue
                                                    visually. Collect random items to use when trying to
                                                    generate new ideas with a group. For example: ‘How
                                                    is the problem with our customer helpline like or
                                                    unlike a bottle of Coca-Cola?’ It’s fun – which is
                                                    one of the best ways to get people thinking
                                                    creatively.</p></li>
                                            </ul>

                                            <div className="left-btn">
                                                <div
                                                    onClick={this.props.handleChangePage('Page3')}
                                                    className="button-next-previous-done thought"> &lt;&lt; Previous
                                                </div>
                                            </div>
                                            <div className="right-btn">
                                                <div
                                                    onClick={this.props.handleChangePage('Page5')}
                                                    className="button-next-previous-done thought">Next &gt;&gt;</div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </section>
                    </div>
                </div>
            </div>
        </div>;
    }
}